// The branches page stays mounted across a language switch: the route is the
// same, only getServerSideProps runs again and hands it the new locale's
// records. The branch picked under the previous locale therefore has to be
// found again in the new list, and a branch the new list no longer has must
// not linger as a stale label.
//
// Each locale's store-locator records are their own Magento entities — the
// Arabic and English lists share almost no `id` — while a physical branch
// carries the same `store_code` attribute in both. So the store code names
// the same branch across locales, and the id only covers records without one.
const storeCode = (branch) => branch?.attributes?.store_code?.value ?? null;

const sameKey = (a, b) => a != null && b != null && String(a) === String(b);

const sameBranch = (a, b) =>
  sameKey(storeCode(a), storeCode(b)) || sameKey(a?.id, b?.id);

// the same branch from `branches`, else its first record, else nothing
export const reconcileBranchSelection = (current, branches) => {
  const list = Array.isArray(branches) ? branches : [];
  return (
    list.find((branch) => sameBranch(branch, current)) ?? list.at(0) ?? null
  );
};
